const encode = (data) => {
  return reverse(btoa(unescape(encodeURIComponent(JSON.stringify(data))))) + randomString(7)
}
const encodeToken = (data) => {
  data = data + randomString(5)
  return reverse(btoa(unescape(data))) + randomString(10)
}
const encodeRichmenu = (data) => {
  return reverse(btoa(unescape(encodeURIComponent(JSON.stringify(data))))) + randomString(5)
}

const encodeAuthen_news = (data) => {
  return randomString(7) + reverse(btoa(unescape(encodeURIComponent(JSON.stringify(data))))) + randomString(10)
}

function reverse (s) {
  return s.split('').reverse().join('')
}

function randomString (num) {
  var text = ''
  var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  for (var i = 0; i < num; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length))
  }
  return text
}

export default {
  encode,
  encodeToken,
  encodeRichmenu,
  encodeAuthen_news
}



// WEBPACK FOOTER //
// ./src/services/encode.js